/* eslint-disable jsx-a11y/alt-text */
/**
 * Container for Mobile section of Onboarding page
 *
 * @module containers/MobileSection
 */
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import ButtonT3 from '../../components/lib/ButtonT3/ButtonT3';
import {
  Icons as OnboardingIcons,
  Images as OnboardingImages,
  messages as OnboardingMessages,
  PurchaseLinks,
  SectionNames,
  StatsOnboardingActions,
} from '../../constants/Onboarding';
import * as Utils from '../../utils';

import SectionCircle from './SectionCircle';

import './MobileSection.scss';

export class MobileSection extends React.Component {
  static propTypes = {
    isMobileDevice: PropTypes.bool.isRequired,
    appLink: PropTypes.string.isRequired,
    appLinkCtaText: PropTypes.object.isRequired,
    mobileSectionRef: PropTypes.object.isRequired,
    isIEorEdge: PropTypes.bool,
    linkClicked: PropTypes.func.isRequired,
    appStoreClicked: PropTypes.func.appStoreClicked,
  };

  handleStoreClick = url => {
    this.props.appStoreClicked();
    switch (url) {
      case PurchaseLinks.ITUNES:
        this.props.linkClicked(StatsOnboardingActions.CLICK_IOS_STORE);
        break;
      case PurchaseLinks.GOOGLE:
        this.props.linkClicked(StatsOnboardingActions.CLICK_GOOGLE_STORE);
        break;
    }
    return true;
  };

  renderDownloadAppLink = (title, url, imageSrc) => {
    return (
      <a
        className='MobileSection__downloadAppLink'
        title={title}
        href={url}
        target='_blank'
        onClick={() => this.handleStoreClick(url)}
        rel='noreferrer'
      >
        {Utils.Url.isValidImgUrl(imageSrc) && <img src={imageSrc} />}
      </a>
    );
  };

  renderMobileCTAButton = () => {
    return (
      <ButtonT3
        href={this.props.appLink}
        isExternalLink={true}
        onClick={() => this.handleStoreClick(this.props.appLink)}
        size='large'
      >
        <FormattedMessage {...this.props.appLinkCtaText} />
      </ButtonT3>
    );
  };

  renderDownloadAppButtons = () => {
    return (
      <div className='MobileSection__downloadAppLinks'>
        {this.renderDownloadAppLink(
          'Download on the App Store',
          PurchaseLinks.ITUNES,
          OnboardingImages.MOBILE_GET_IT_FROM_APPLE,
        )}
        {this.renderDownloadAppLink(
          'Get it on Google Play',
          PurchaseLinks.GOOGLE,
          OnboardingImages.MOBILE_GET_IT_FROM_GOOGLE,
        )}
      </div>
    );
  };

  render() {
    return (
      <div className='MobileSection__contentSection'>
        {!this.props.isMobileDevice && (
          <SectionCircle
            type={SectionNames.MOBILE}
            svg={OnboardingIcons.DeviceIcon}
            sectionRef={this.props.mobileSectionRef}
            isIEorEdge={this.props.isIEorEdge}
          />
        )}
        <div
          id={SectionNames.MOBILE}
          ref={this.props.mobileSectionRef}
          className='Onboarding__contentSection__container'
        >
          <div className='MobileSection__text Onboarding__contentSection__content'>
            <h3 className='Onboarding__contentSection__title'>
              <FormattedMessage {...OnboardingMessages.mobileSectionTitle} />
            </h3>
            <p className='Onboarding__contentSection__subTitle'>
              <FormattedMessage {...OnboardingMessages.mobileSectionSubTitle1} />
            </p>
            <p className='Onboarding__contentSection__subTitle'>
              <FormattedMessage {...OnboardingMessages.mobileSectionSubTitle2} />
            </p>
          </div>
          <div className='MobileSection__CTA Onboarding__contentSection__content'>
            {this.props.isMobileDevice
              ? this.renderMobileCTAButton()
              : this.renderDownloadAppButtons()}
          </div>
          <div className='MobileSection__img Onboarding__contentSection__content'>
            <img
              className='MobileSection__downloadAppDevices'
              src={OnboardingImages.MOBILE_DEVICE}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default MobileSection;
